export default "__VITE_ASSET__CYynAm8T__"